'use strict';

angular.module('sellersService')
.factory('AgencyService', ['appInfo', '$log', '$rootScope', '$http', '$q'
    , function (appInfo, $log, $rootScope, $http, $q) {
        
    var service = {}
        , api_key = $rootScope.api_key
        , code    = $rootScope.currentUser.authdata
        , expires =  moment().add(15, 'm').unix();
    
    // methods which will fetch data from API and *returns* a promise
    service.getAgency = function(identifier) {
        var dfd = $q.defer();
       
        $http({
            url: appInfo.endpoint+'agency/details.json', 
            method: "GET",
            params: {identifier: identifier, api_key: appInfo.pkey},
        }).success(function(data, status, headers, config) {
            dfd.resolve(data);
        }).error(function(data, status, headers, config) {
            dfd.reject("Error: request returned status " + status); 
        });
        
        return dfd.promise;
    };

    service.getListings = function(identifier) {
        var dfd = $q.defer();
        
        $http({
            url: appInfo.endpoint+'agency/listings.json', 
            method: "GET",
            transformResponse: function (data, headers) {
             var response = JSON.parse(data);
             angular.forEach(response.result[0].listings, function(listing){
                if(listing.showAddress == "1"){
                    listing.address = (listing.streetUnit!="")? 
                        listing.streetUnit+"/"+listing.streetRef+" "+listing.streetName+" "+listing.streetType+", "+listing.locationName :
                        listing.streetRef+" "+listing.streetName+" "+listing.streetType+", "+listing.locationName;
                } else {
                    listing.address = listing.locationName;
                }

                listing.suburb = listing.locationName;
                listing.priceView = listing.priceView;

                // Images --
                var images  = listing.marketing[0].images;
                listing.images = [];

                if(typeof images != 'undefined') {
                    if(typeof images.img != 'undefined' && images.img.length){
                        angular.forEach(images.img, function(image){
                            listing.images.push(image);
                        }); 
                    } else {
                        listing.images.push("http://dummyimage.com/800x533&text=Wiseberry");
                    }
                } else {
                    listing.images.push("http://dummyimage.com/800x533&text=Wiseberry");
                }

                // Heading & Description --
                listing.desc = listing.marketing[0].detail;
                listing.heading = listing.marketing[0].heading;
              });
              
              return response.result[0];

            },
            params: {usercode: code, identifier: identifier, api_key: appInfo.pkey}
        }).success(function(data, status, headers, config) {
            dfd.resolve(data);
        }).error(function(data, status, headers, config) {
            dfd.reject("Error: request returned status " + status); 
        });
        
        return dfd.promise;

    };


    service.getAgencyLeaders = function(identifier) {
        var dfd = $q.defer();
        $http({
            url: appInfo.endpoint + 'agency/agentdisplay.json'
            ,method: "GET"
            ,params: {usercode: code, identifier: identifier, api_key: appInfo.pkey, roles: '5'}
        }).success(function(data, status, headers, config) {
            dfd.resolve(data);
        }).error(function(data, status, headers, config) {
            dfd.reject("Error: request returned status " + status);
        });
        return dfd.promise;
    };
    
    return service;

}]);